// extracted by mini-css-extract-plugin
module.exports = {"root":"Switch_root__pZEKi","checkbox":"Switch_checkbox__egGda","switchWrapper":"Switch_switchWrapper__N2776","withText":"Switch_withText__k_Nrr","bold":"Switch_bold__Yd9XG"};